import React from 'react';
import { InsightsTimeframeProvider } from 'shared/contexts/insights-timeframe';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';
import { LimitKeys } from 'shared/types/limit-keys';

import { GoalsInsights } from './components/goals-insights';
import { HabitsInsights } from './components/habits-insights';
import { LifescanInsights } from './components/lifescan-insights';
import { PageTopBar } from './components/page-top-bar';
import { PremiumMessage } from './components/premium-message';
import { useKeyboardShortcutTimeframeSelection } from './hooks/use-keyboard-shortcut-timeframe-selection';
import * as Styled from './insights.style';

export const Insights = () => {
  const { allowed } = usePremiumFeatureAllowed(LimitKeys.Insights, {});
  useKeyboardShortcutTimeframeSelection();

  return (
    <InsightsTimeframeProvider>
      <Styled.Container>
        <Styled.Main>
          <PageTopBar />
          {allowed ? (
            <>
              <GoalsInsights />
              <HabitsInsights />
              <LifescanInsights />
            </>
          ) : (
            <PremiumMessage />
          )}
        </Styled.Main>
      </Styled.Container>
    </InsightsTimeframeProvider>
  );
};
